import { render, staticRenderFns } from "./EditarVersaoApp.vue?vue&type=template&id=1cd2b250&"
import script from "./EditarVersaoApp.vue?vue&type=script&lang=js&"
export * from "./EditarVersaoApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports